import { useEffect } from "react";

const { isExcluded } = require('../utils');

function BeforeUnloadGuard () {
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      // 除外ページではページを離れる前の確認をしない
      if(isExcluded()) return;
      e.preventDefault();
      e.returnValue = ""; // Chrome/Firefoxで必須
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return null;
}

export default BeforeUnloadGuard